import { Tooltip } from "antd";
import AddIcon from "assets/icons/AddIcon";
import styles from "./style.module.scss";

export default function AddClassButton({ onClick }: { onClick?: () => void }) {
  return (
    <Tooltip title="Add more labels to the seed" mouseEnterDelay={0.6}>
      <div className={styles.addIcon} onClick={onClick}>
        <AddIcon />
        Add Labels
      </div>
    </Tooltip>
  );
}
